import React, { useState } from 'react';
import styles from "./FullTeamMeeting.module.scss"
import InteractionContainer from "../../partials/InteractionContainer/InteractionContainer";
import Header from "../../partials/Header";
import Button from "../../partials/Button";
import Participants from "./Participants"
import Slides from './Slides';

const FullTeamMeeting =  ({ goBackToPreviousSegment, breadcrumbs, data, onComplete }) => {
    
    const [meetingIndex, setMeetingIndex] = useState(0)
    const [activeMeeting, setActiveMeeting] = useState(data.meetings[meetingIndex])
    const [startConversation, setStartConversation] = useState(false)
    const [showDialog, setShowDialog] = useState(false)
    const [meetingComplete, setMeetingComplete] = useState(false)
    const [nextMeeting, setNextMeeting] = useState(false)

    const getParticipants = (meeting) => {
        return data.participants.filter(
            (participant) =>  meeting.participants.find(id =>participant.id===id)
        )
    }

    const endConversation = () =>{
        setStartConversation(false)
        setShowDialog(true)
    }

    const handleSlideFeedback = (feedback) => {
        setStartConversation(true)
        setActiveMeeting({...activeMeeting, conversation: feedback})
    }

    const handleCompleteSlides = () => {

        if(meetingIndex < data.meetings.length-1) {
            setNextMeeting(true)

        } else {
            setMeetingComplete(true)
        }
    }

    const handleNextMeeting = () => {
        setMeetingIndex(meetingIndex+1)
        setActiveMeeting(data.meetings[meetingIndex+1])
        setStartConversation(true)
        setShowDialog(false)
        setNextMeeting(false)

    }

    return (
        <InteractionContainer breadcrumbs={breadcrumbs} >

            <Header backButtonHandler={goBackToPreviousSegment} intro={activeMeeting.instructions} />

                <div className={styles.meetingRoom}>

                    <Slides 
                        slides={activeMeeting.slides}
                        dialog={showDialog}
                        feedback={handleSlideFeedback}
                        onComplete={handleCompleteSlides}
                    />
                    <Participants 
                        participants={getParticipants(activeMeeting)} 
                        conversation={activeMeeting.conversation}
                        startConversation={startConversation} 
                        endConversation={endConversation}
                    />
                    {/* <p>Meeting {meetingIndex+1} / {data.meetings.length}</p> */}
                    {!startConversation && !showDialog && <Button text="Start Meeting" onClick={()=>setStartConversation(true)} /> }
                    {meetingComplete && <Button text="Continue" onClick={onComplete} /> }
                    {nextMeeting && <Button text="Next Meeting" onClick={handleNextMeeting} /> }
                </div>
           
        </InteractionContainer>
    )
}

export default FullTeamMeeting